
import React, { useEffect, useState, useRef } from 'react';
import * as affl from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from 'axios';
import '../affiliation.css';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { CommonAxiosGet, CommonAxiosPostLogin } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import Cookies from "js-cookie";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import * as bie from "react-bootstrap";
import { TfiReload } from "react-icons/tfi";
import Swal from 'sweetalert2';
import preval from "preval.macro"
import { getTokenExpiry } from '../CommonUtils/CommonServices';
import Websitepdf from '../Apcfss_Website_Policy.pdf';
import newGif from '../new.gif';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';


export default function IndexPage() {
  const [getdates, setdates] = useState([]);
  const dispatch = useDispatch();
  const [flipCards, setFlipCards] = useState({});
  const [getcaptchaID, setCaptchaID] = useState("");
  const [loginType, setLoginType] = useState('')
  const [clgType, setClgType] = useState([]);
  const navigate = useNavigate();
  const [getcaptcha, setcaptch] = useState();
  const [showPassword, setShowPassword] = useState(false);
  var md5 = require('md5');
  function getPaymentCheck(decodedToken) {
    CommonAxiosGet(config.url.API_URL + 'getpaymentCheck').then((res) => {
      if (res?.data?.scode === '01') {
        let pay = res?.data?.payment
        setpayment(res?.data?.payment);
        if (decodedToken?.login_type === 'college') {
          if (pay === 'done') {
            navigate('/dashboard')
          }
          else {
            navigate('/payment')
          }

        } else {
          navigate('/dashboard')
        }

      } else {
        setpayment('')
      }
    })
  }
  function GetCaptcha() {
    let url = config.url.API_URL + `captcha `;
    axios.get(url).then((res) => {
      if (res?.data?.scode === '01') {
        setcaptch(res?.data?.sdesc)
        setCaptchaID(res?.data?.captchaId)

      } else {
        setcaptch('')
        setCaptchaID('')
      }
    })
  }
  useEffect(() => {
    GetCaptcha();


  }, [])

  const getAcademicYear = () => {
    const currentYear = '2025-26'
    // const currentYear = new Date().getFullYear();
    // const nextYear = currentYear + 1;
    // return `${currentYear}-${nextYear.toString().slice(-2)}`;
    return currentYear
  };
  const [paymentFlag, setpayment] = useState('')
  const [academicYear] = useState(getAcademicYear());
  const validations = Yup.object().shape({
    userId: Yup.string().required('required'),
    password: Yup.string().required('required'),
    captcha: Yup.string().required('required'),
  })

  const formik = useFormik({
    initialValues: {
      userId: '',
      password: '',
      captcha: '',
      captchaId: ''
    },
    validationSchema: validations,
    onSubmit: (val) => {
      const updatedLoginType = (loginType === 'university' && val?.userId?.substring(0, 4) === 'ffca')
        ? 'ffca'
        : loginType;

      const body = {
        userId: val?.userId,
        userPassword: md5(val?.password),
        captcha: val?.captcha,
        captchaId: getcaptchaID,
        acYear: academicYear,
        loginType: updatedLoginType,
        ...(loginType !== 'university' && { clgType: clgType })
      };

      CommonAxiosPostLogin(config.url.local, body).then((res) => {
        if (res?.data?.responseCode === '01') {
          var decodedToken = jwtDecode(res?.data?.accessToken);
          var accessTokenTime = new Date(decodedToken.exp * 1000);
          var decoded_refresh = jwtDecode(res.data.refreshToken);
          var rfTokenTime = new Date(decoded_refresh.exp * 1000);
          const tokenExpiry = getTokenExpiry(res.data.accessToken);
          // const tokenExpiry = getTokenExpiry(res.data.accessToken);
          const refreshExpiry = getTokenExpiry(res.data.refreshToken);
          Cookies.set("token", res.data.accessToken, { expires: accessTokenTime });
          Cookies.set("tokenTime", tokenExpiry);
          Cookies.set("refreshTokenTime", refreshExpiry);
          Cookies.set("refreshToken", res.data.refreshToken, { expires: rfTokenTime });
          dispatch({ type: "LOGIN_DETAILS", payload: { isLoggedIn: true, user: val.userId, token: res?.data?.accessToken, userLoginDetials: decodedToken } });
          sessionStorage.setItem('user_gr_code', decodedToken?.user_gr_code);
          console.log("decodedToken?.user_gr_code", decodedToken?.user_gr_code)

          sessionStorage.setItem('ac_year', decodedToken?.ac_year);
          sessionStorage.setItem('loginType', decodedToken?.login_type);

          sessionStorage.setItem('user_id', decodedToken?.user_id);
          sessionStorage.setItem('ub_code', decodedToken?.ub_code);
          sessionStorage.setItem('instName', decodedToken?.empl_first_name);
          const idnamevalue = getdates?.filter((id) => {
            return id?.ub_code == decodedToken?.ub_code;
          });
          sessionStorage.setItem('collegeName', idnamevalue[0]?.ub_name)
          sessionStorage.setItem('collegeLogo', idnamevalue[0]?.logo_path)
          CommonAxiosGet(config.url.API_URL + 'getServices', dispatch).then((res) => {
            if (res?.data?.scode === '01') {
              const data = res?.data?.services;
              sessionStorage.setItem('menuData', JSON.stringify(data))
            }
            else {

            }
          })
          getPaymentCheck(decodedToken)


        }

        else {
          Swal.fire({
            text: res?.data?.sdesc,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'OK',
            backdrop: false,
          }).then((result) => {
            if (result.isConfirmed) {
              if (res?.data?.sdesc === "Invalid Captcha") {
                formik?.setFieldValue('captcha', '');
                GetCaptcha();

              }

              if (res?.data?.sdesc === "Invalid login credentials! Try again.") {
                formik?.setFieldValue('captcha', '');
                formik?.setFieldValue('userId', '');
                formik?.setFieldValue('password', '');
                document.getElementById("password").value = null;
                GetCaptcha();
              }
              if (res?.data?.sdesc === "Please Check  type of College") {
                formik?.setFieldValue('captcha', '');
                formik?.setFieldValue('userId', '');
                formik?.setFieldValue('password', '');
                document.getElementById("password").value = null;
                GetCaptcha();

              }
            }
          });
        }
      })

    }

  })
  const handleCardClick = (id, name, logo, type) => {
    formik?.setFieldValue('captcha', '')
    formik?.setFieldValue('userId', '')
    formik?.setFieldValue('password', '')
    setLoginType(type)
    sessionStorage.setItem('collegeName', name)
    sessionStorage.setItem('collegeLogo', logo)
    sessionStorage.setItem('LoginDates', JSON.stringify(getdates))
    dispatch({ type: "Login_dates", payload: getdates });
    setFlipCards((prevState) => {
      if (prevState[id]) {
        return {
          ...prevState,
          [id]: false,
        };
      } else {
        const newState = Object.keys(prevState).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {});
        return {
          ...newState,
          [id]: true,
        };
      }
    });
  };


  function getlogindates() {
    const ac_year = "2025-26";
    axios.get(config?.url?.API_URL + "GetLoginDates/" + ac_year).then(res => {
      setdates(res?.data?.LoginDates);
      // sessionStorage.setItem('LoginDates', JSON.stringify(res?.data?.LoginDates))
      dispatch({ type: "Login_dates", payload: res?.data?.LoginDates });
    });
  }

  useEffect(() => {
    getlogindates();
    sessionStorage.clear()
    Cookies.remove('token')
    Cookies.remove('tokenTime')
    Cookies.remove('refreshToken')
    Cookies.remove('refreshTokenTime')
  }, []);

  const [modal, setModal] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const marqueeRef = useRef(null);
  const [clgtypedisplay, setclgtypedisplay] = useState('')
  return (
    <>
      <div className='total-affl-page'>
        <img src='../img/top-background.png' className='img-fluid top-background' />
        <img src='../img/afl-bg.png' className='img-fluid middle-background' />
        {/* <affl.Navbar expand="lg">
          <affl.Container fluid>
            <affl.Navbar.Brand href="#">
              <div className='aff-aplogo-content'>
                <img src='../img/ap-logo.png' className='img-fluid aff-aplogo' />
                <p className='aff-logo-text'>Andhra Pradesh<br></br>Affiliation Application 2025 - 2026</p>
              </div>
            </affl.Navbar.Brand>
            <div className="university-login">
              <button className="university-login-btn" type='button' onClick={() => {
                setclgtypedisplay("University")
                setModal(true); setLoginType('university');
                formik?.setFieldValue('captcha', '')
                formik?.setFieldValue('userId', '')
                formik?.setFieldValue('password', '')
              }}>University Login</button>
            </div>
          </affl.Container>
        </affl.Navbar> */}
        <affl.Navbar expand="lg" className='affl-navnew'>
          <affl.Container fluid>
            <affl.Navbar.Brand href="#">
              <div className='aff-aplogo-content'>
                <img src='../img/ap-logo.png' className='img-fluid aff-aplogo' />
                <p className='aff-logo-text'>Andhra Pradesh<br></br>Affiliation Application 2025 - 2026</p>
              </div>
            </affl.Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">

              <Nav className="ms-auto">
                <Nav.Link href="#home" className="active mx-2">Home</Nav.Link>
                <Nav.Link href="#link" className="mx-2">About Us</Nav.Link>
                <Nav.Link href={Websitepdf} target="_blank" rel="noopener noreferrer"
                  className="mx-2"> APCFSS Website Policies <img
                    src={newGif}
                    alt="new"
                    style={{ width: "30px", marginLeft: "6px" }}
                  /></Nav.Link>
                <Nav.Link>

                  <div className="university-login">
                    <button className="university-login-btn" type='button' onClick={() => {
                      setclgtypedisplay("University")
                      setModal(true); setLoginType('university');
                      formik?.setFieldValue('captcha', '')
                      formik?.setFieldValue('userId', '')
                      formik?.setFieldValue('password', '')
                    }}>University Login</button>
                  </div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>

          </affl.Container>
        </affl.Navbar>

        <affl.Modal show={modal} onHide={() => setModal(false)} className='modal fade login-modal-page' size='md' backdrop="static">
          <affl.Modal.Header closeButton>
            <div>
              <h1 className="modal-title fs-5" id="exampleModalLabel"> {clgtypedisplay}        Login </h1>
              <p>Welcome back to affiliation application!</p>
            </div>
          </affl.Modal.Header>
          <affl.Modal.Body>
            <FormikProvider value={formik}>
              <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>
                <label htmlFor="userId" className='form-headings'>User ID</label>
                <Field
                  type='text'
                  name='userId'
                  className='form-control'
                  placeholder='Enter User Id'
                  autoComplete="new-password"
                  maxLength="12"
                />
                <ErrorMessage name='userId' className='text-error' component='div' />

                <div className="password-container mt-4" style={{ position: 'relative' }}>
                  <label htmlFor="password" className='form-headings'>Password</label>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    className="form-control"
                    placeholder="Password"
                    autoComplete="new-password"
                    maxLength="20"
                    id="password"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="toggle-password-btn"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '26px',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      color: '#000',
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <ErrorMessage name='password' className='text-error' component='div' />

                <bie.InputGroup className="mb-2 mt-4">
                  <TfiReload onClick={() => { GetCaptcha() }} size={20} className="mt-2" />&nbsp;
                  <img src={getcaptcha} alt="Captcha" width='45%' height='50%' />
                  <Field
                    placeholder="Enter Captcha"
                    name="captcha"
                    className="form-control mt-2"
                    maxLength="5"
                  />
                  <ErrorMessage name='captcha' className='text-error' component='div' />
                </bie.InputGroup>

                <button type='submit' className='btn btn-success btn-sm mt-3 total-signin-button'>Sign In</button>
              </Form>
            </FormikProvider>
          </affl.Modal.Body>
        </affl.Modal>
        {/* ------------Main Body-------------- */}
        <affl.Container fluid className='mt-5'>
          <div className='main-affl-body'>

            <div className='latest-news'>
              <div className='latest-news-title'>
                <p>Latest Updates</p>
              </div>
              <div className='marquee-text'>

                <marquee
                  ref={marqueeRef}
                  behavior="scroll"
                  direction="left"


                  tabIndex={0}
                  onMouseOver={() => marqueeRef.current && marqueeRef.current.stop()}
                  onMouseOut={() => marqueeRef.current && marqueeRef.current.start()}
                  onFocus={() => marqueeRef.current && marqueeRef.current.stop()}
                  onBlur={() => marqueeRef.current && marqueeRef.current.start()}>
                  <a href='' style={{ color: 'red', textDecoration: 'none' }}>Affiliation portal for professional colleges  & Degree colleges for the academic year 2025-26 is now open. </a>

                </marquee>
              </div>
            </div>
            {getdates && getdates?.length > 0 && (
              <>

                <affl.Row className='mb-0'>
                  {getdates.map((university) => (
                    <affl.Col
                      key={university.ub_code}
                      xxl={3}
                      xl={4}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      style={{ padding: '5px' }}
                    >
                      <div className={`university-card ${flipCards[university?.ub_code] ? 'university-card-flip' : ''}`}>
                        <div className="university-card-inner">
                          {/* FRONT SIDE */}
                          <div className="university-card-front">
                            <div className="university-header">
                              <img
                                src={`https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/Affiliation/${university?.logo_path}`}
                                alt="University Logo"
                                className="university-logo"
                              />
                            </div>
                            <div className="university-name">{university?.ub_name}</div>
                            <div className='last-date'><p>Last Date : <span>{university?.enddate}</span></p></div>
                            <div className="university-actions">
                              <button className="college-login" onClick={() => { setclgtypedisplay("College"); handleCardClick(university?.ub_code, university?.ub_name, university?.logo_path, "college") }}>
                                College Login
                              </button>
                              <button className="ffca-login" disabled
                                onClick={() => { setclgtypedisplay("FFCA"); handleCardClick(university?.ub_code, university?.ub_name, university?.logo_path, "ffca") }}>
                                FFCA Login
                              </button>
                            </div>
                          </div>

                          {/* BACK SIDE */}
                          <div className="university-card-back">
                            <div className="additional-buttons">
                              <div className="button-row">
                                <button className="btn-red" onClick={() => { setModal(true); setClgType([113, 124, 102]) }}>ENGINEERING</button>
                                <button className="btn-blue" onClick={() => { setModal(true); setClgType([135, 138]) }}>PHARMACY</button>
                              </div>
                              <div className="button-row">
                                <button className="btn-green" onClick={() => { setModal(true); setClgType([118, 145, 102]) }}>DEGREE</button>
                                <button className="btn-yellow" onClick={() => { setModal(true); setClgType([104, 122]) }}>B.ED</button>
                              </div>
                              <div className="button-row">
                                <button className="btn-purple" onClick={() => { setModal(true); setClgType([104, 122]) }}>B.P.ED</button>
                                <button className="btn-orange" onClick={() => { setModal(true); setClgType([131, 142]) }}>LAW</button>
                              </div>
                              <div className="button-row">
                                <button className="btn-pink" onClick={() => { setModal(true); setClgType([111, 147]) }}>MBA</button>
                                <button className="btn-gray" onClick={() => { setModal(true); setClgType([136]) }}>MCA</button>
                              </div>
                              <button className="back-btn" onClick={() => handleCardClick(university.ub_code)}>
                                Back
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </affl.Col>
                  ))}
                </affl.Row>


              </>
            )}
          </div>
        </affl.Container>
        <affl.Container fluid>

          <div className="downloads-notices">
            <div className="info-container">
              <div className="col-xs-12 col-sm-12 col-lg-4 col-md-4" style={{ color: '#c2a2a2ff', fontSize: '18px' }}>
                Site last updated(build) on: {preval`module.exports = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });`}
              </div>
              <affl.Row className='mb-0'>

                <affl.Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={12}>
                  <div className="queries-section">
                    <div>
                      <div className="section-header">
                        <span>For Queries and Instant Response please whatsapp</span>
                      </div>
                      <div className="queries-content">
                        <ul>
                          <li>To Report Technical Issues - Colleges shall join the WhatsApp group through the <a href="#">Link</a></li>
                        </ul>
                        <div className="query-details">
                          <p>Colleges shall give:</p>
                          <ol>
                            <li>Any Desk Id</li>
                            <li>Screen Shot of the Issue</li>
                            <li>Issue Description with the WhatsApp group</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="downloads-section">
                    <div>
                      <div className="section-header downloads-header">
                        <span>Downloads & Notices</span>
                      </div>
                      <div className="downloads-content">
                        <p>
                          Please click on respective type of institute in order to login. <br />For example, if yours is Engineering college, click on the Engineering Tab on the home page or if yours is Degree College, click on the Degree Tab on the home page etc.
                        </p>
                        <p>
                          To enter Geo-Position (Lat, Long coordinates in Land Details), <a href="#">Click here to download the Android App</a>
                        </p>
                        <p style={{ fontSize: "19px", color: "white", fontWeight: "300px" }}> <a href={Websitepdf} target="_blank" rel="noopener noreferrer" download>     👉 Click here to  download, APCFSS Website policies </a> </p>
                      </div>
                    </div>
                  </div>
                </affl.Col>
                <affl.Col xxl={5} xl={5} lg={5} md={12} sm={12} xs={12} className='my-auto'>
                  <div className='working-person text-center'>
                    <img src='../img/working-person.png' className='img-fluid' alt='working-person' />
                  </div>
                </affl.Col>
              </affl.Row>
              {/* <div className="browser-section">
                <div className="browser-header">
                  <span> <FaFirefoxBrowser />Browser</span>
                </div>
                <div className="browser-content">
                  <p>Best Viewed in Mozilla FireFox</p>
                </div>
              </div> */}
            </div>
          </div>
        </affl.Container >
      </div >
      <div className='affl-footer'>
        <p>Designed and Developed by</p>
        <a href='https://apcfss.in/'>
          <img src="../img/apcfss.svg" className='img-fluid' />
        </a>
      </div>
    </>
  );
}